// src/data/disciplineProvisionsFor.js
//
// T5 / D-3, D-13 (2026-10-15): what the case's own agreement says about discipline, grouped by phase, from the
// generated src\data\disciplineProvisions.js (the rule map's DISC- rows, verbatim, with file:line). Pure.
//   charge   - the charge and its notice: specificity, precise charge, the knowledge rule      (D-3: the objection's source)
//   hearing  - the right to a hearing and its conduct: representation, witnesses, cross-examination, transcript  (D-13)
//   holding  - held out of service, the waiver track, pre-hearing resolution
//   after    - decision, appeal, record removal, make-whole, remedy
//   other    - everything else (attendance, medical, decertification ...)
// An agreement with no bridge to the map returns { bridged: false } - said so on the screen, never an empty list
// that reads as "this agreement says nothing".
import { DISCIPLINE_PROVISIONS, MAP_KEY_BY_AGREEMENT } from './disciplineProvisions';
import { canonicalAgreementKey } from './claimRequirements';

export const PHASES = [
  { key: 'charge', label: 'The charge and its notice', test: /charge|knowledge-rule|investigation-outside/ },
  { key: 'holding', label: 'Held out of service, the waiver, resolution before the hearing', test: /out-of-service|withholding|waiver|pre-hearing|management-non-appe/ },
  { key: 'hearing', label: 'The hearing - check each at the hearing, object on the record if it is not met', test: /hearing|representation|witnesses|transcript/ },
  { key: 'after', label: 'The decision, the appeal and after', test: /decision|appeal|record-removal|make-whole|remedy|reinstatement|time-limits|summary-dismissal|termination|progressive|just-cause/ },
];

export function phaseOf(id) {
  const s = String(id || '').replace(/^DISC-/, '');
  const p = PHASES.find((x) => x.test.test(s));
  return p ? p.key : 'other';
}

export function provisionsFor(applicableAgreement) {
  const name = canonicalAgreementKey(applicableAgreement) || String(applicableAgreement || '');
  const key = MAP_KEY_BY_AGREEMENT[name] || null;
  if (!key) return { bridged: false, key: null, groups: [], count: 0 };
  const rows = DISCIPLINE_PROVISIONS.filter((r) => r.key === key);
  const order = ['charge', 'holding', 'hearing', 'after'];
  const labels = Object.fromEntries(PHASES.map((p) => [p.key, p.label]));
  const groups = order.concat(['other']).map((g) => ({
    key: g, label: labels[g] || 'Other discipline provisions', rows: rows.filter((r) => phaseOf(r.id) === g),
  })).filter((g) => g.rows.length);
  return { bridged: true, key, groups, count: rows.length };
}
